{
  "worlds": {
    "CoralLagoon": {
      "name": "Coral Lagoon",
      "loadingMessage": "Loading water simulation",
      "glb": "CL_World_0223",
      "lookGlbs": [
        "Look_CL_GreenFurSweater_0211",
        "Look_CL_Poncho_0211",
        "Look_CL_ShirtChino_0214",
        "Look_CL_TeePintuckPant_0211"
      ],
      "plantGlbs": ["CL_Venturecoral_0215", "CL_Budblob_0215"],
      "instancedMeshes": [
        "Icosphere",
        "Coral-Flower-Stack",
        "Coral-Flower",
        "Coral-Tree"
      ],
      "soundtrack": "Soundtrack_CL",
      "skyConfig": {
        "colourFallback": "#93b7c5",
        "colourSky": "#568c94",
        "colourHorizon": "#eed9c9",
        "colourHighlight": "#999cc7",
        "smoothstepControl": "0.5"
      }
    },
    "FieldTrip": {
      "name": "Field Trip",
      "loadingMessage": "Loading very large flowers",
      "glb": "FT_World_0302",
      "lookGlbs": [
        "FT_Bomber_0211",
        "Look_FT_Coveralls_0214",
        "FT_KnitVest_0211",
        "FT_Shirtdress_0211"
      ],
      "plantGlbs": ["FT_Swellberries_0216", "FT_Multipod_0216"],
      "instancedMeshes": [
        "bronze-clover-a-",
        "bronze-clover-b-",
        "bronze-clover-c-",
        "Dandilion-Seed"
      ],
      "soundtrack": "Soundtrack_FT",
      "skyConfig": {
        "colourFallback": "#7da8dd",
        "colourSky": "#497FB9",
        "colourHorizon": "#A8C6CC",
        "colourHighlight": "#6D94BC",
        "smoothstepControl": "0.5"
      }
    },
    "FungiForest": {
      "name": "Fungi Forest",
      "loadingMessage": "Loading Mycelium Network",
      "glb": "FF_World_0223",
      "lookGlbs": [
        "Look_FF_CropSweater_0220",
        "Look_FF_RibSweater_0220",
        "Look_FF_Shirtdress_0330"
      ],
      "plantGlbs": ["FF_Chainshroom_0215", "FF_Rotwood_0215"],
      "instancedMeshes": [
        "Tree1-Trunk",
        "Tree2-Trunk",
        "Tree-Bulb",
        "fungi-cluster"
      ],
      "soundtrack": "Soundtrack_FF",
      "skyConfig": {
        "colourFallback": "#3c3b38",
        "colourSky": "#2e1e2a",
        "colourHorizon": "#10c300",
        "colourHighlight": "#4b4952",
        "smoothstepControl": "0.3"
      }
    }
  },
  "looks": {
    "CL_GreenFurSweater": {
      "name": "Algae Bloom Turtleneck<br/>Crop Sweatshirt and Pants",
      "world": "CoralLagoon",
      "glb": "Look_CL_GreenFurSweater_0211",
      "arGlb": "Look_CL_GreenFurSweater_0214-for-AR",
      "arUsdz": "Look_CL_GreenFurSweater_0323-for-AR",
      "items": {
        "Algae_Bloom_Turtleneck": {
          "name": "Algae Bloom Turtleneck<br />Crop Sweatshirt",
          "shopUrl": "https://shop.cash.app/product/algae-bloom-turtleneck-crop-sweatshirt/110",
          "isSoldOut": false
        },
        "Budding_Leggings": {
          "name": "Budding Leggings",
          "shopUrl": "https://shop.cash.app/product/budding-leggings/123",
          "isSoldOut": false
        }
      }
    },
    "FT_Shirtdress": {
      "name": "Full Bloom<br/>Long Shirt Dress",
      "world": "FieldTrip",
      "glb": "FT_Shirtdress_0211",
      "arGlb": "Look_FT_Shirtdress_0214-for-AR",
      "arUsdz": "Look_FT_Shirtdress_0322-for-AR",
      "items": {
        "Full_Bloom_Long_Shirt_Dress": {
          "name": "Full Bloom<br/>Long Shirt Dress",
          "shopUrl": "https://shop.cash.app/product/full-bloom-long-shirt-dress/121",
          "isSoldOut": false
        }
      }
    },
    "FF_Shirtdress": {
      "name": "Old Growth<br/>Long Shirt Dress",
      "world": "FungiForest",
      "glb": "Look_FF_Shirtdress_0330",
      "arGlb": "Look_FF_Shirtdress_0330-for-AR",
      "arUsdz": "Look_FF_Shirtdress_0330-for-AR",
      "items": {
        "Old_Growth_Long_Shirt_Dress": {
          "name": "Old Growth<br/>Long Shirt Dress",
          "shopUrl": "https://shop.cash.app/product/old-growth-long-shirt-dress/116",
          "isSoldOut": false
        }
      }
    },
    "CL_Poncho": {
      "name": "Giant Kelp Poncho<br/>Mycelium Ribbed Sweatpants",
      "world": "CoralLagoon",
      "glb": "Look_CL_Poncho_0211",
      "arGlb": "Look_CL_Poncho_0214-for-AR",
      "arUsdz": "Look_CL_Poncho_0323-for-AR",
      "items": {
        "Giant_Kelp_Poncho": {
          "name": "Giant Kelp Poncho",
          "shopUrl": "https://shop.cash.app/product/giant-kelp-poncho/115",
          "isSoldOut": false
        },
        "Mycelium_Ribbed_Sweatpants": {
          "name": "Mycelium Ribbed Sweatpants",
          "shopUrl": "https://shop.cash.app/product/mycelium-ribbed-sweatpants-ivory/114",
          "isSoldOut": false
        }
      }
    },
    "FT_Bomber": {
      "name": "Bitcoin Bloom Bomber<br />Abyss Pintuck Pants",
      "world": "FieldTrip",
      "glb": "FT_Bomber_0211",
      "arGlb": "Look_FT_Bomber_0214-for-AR",
      "arUsdz": "Look_FT_Bomber_0322-for-AR",
      "items": {
        "Bitcoin_Bloom_Bomber": {
          "name": "Bitcoin Bloom Bomber",
          "shopUrl": "https://shop.cash.app/product/bitcoin-bloom-bomber-jacket/109",
          "isSoldOut": false
        },
        "Abyss_Pintuck_Pants": {
          "name": "Abyss Pintuck Pants",
          "shopUrl": "https://shop.cash.app/product/abyss-pintuck-pants/101",
          "isSoldOut": false
        }
      }
    },
    "CL_TeePintuckPant": {
      "name": "Soft Coral Crewneck T-Shirt<br/>Mycelium Ribbed Sweatpants",
      "world": "CoralLagoon",
      "glb": "Look_CL_TeePintuckPant_0211",
      "arGlb": "Look_CL_TeePintuckPant_0214-for-AR",
      "arUsdz": "Look_CL_TeePintuckPant_0322-for-AR",
      "items": {
        "Soft_Coral_Crewneck_T-Shirt": {
          "name": "Soft Coral Ribbed Crewneck T-Shirt",
          "shopUrl": "https://shop.cash.app/product/soft-coral-ribbed-crewneck-t-shirt/90",
          "isSoldOut": false
        },
        "Mycelium_Ribbed_Sweatpants": {
          "name": "Mycelium Ribbed Sweatpants",
          "shopUrl": "https://shop.cash.app/product/mycelium-ribbed-sweatpants-ivory/114",
          "isSoldOut": false
        }
      }
    },
    "FT_Coveralls": {
      "name": "Perennial Coverall",
      "world": "FieldTrip",
      "glb": "Look_FT_Coveralls_0214",
      "arGlb": "Look_FT_Coveralls_0214-for-AR",
      "arUsdz": "Look_FT_Coveralls_0322-for-AR",
      "items": {
        "Perennial_Coverall": {
          "name": "Perennial Coverall",
          "shopUrl": "https://shop.cash.app/product/perennial-coverall-ivory/102",
          "isSoldOut": false
        }
      }
    },
    "FF_RibSweater": {
      "name": "Mycelium Mock Neck Sweatshirt and Sweatpants",
      "world": "FungiForest",
      "glb": "Look_FF_RibSweater_0220",
      "arGlb": "Look_FF_RibSweater_0220-for-AR",
      "arUsdz": "Look_FF_RibSweater_0322-for-AR",
      "items": {
        "Mycelium_Ribbed_Mock_Neck_Sweatshirt": {
          "name": "Mycelium Ribbed Mock Neck Sweatshirt",
          "shopUrl": "https://shop.cash.app/product/mycelium-mock-neck-sweatshirt-ivory/105",
          "isSoldOut": false
        },
        "Mycelium_Ribbed_Sweatpants": {
          "name": "Mycelium Ribbed Sweatpants",
          "shopUrl": "https://shop.cash.app/product/mycelium-ribbed-sweatpants-ivory/114",
          "isSoldOut": false
        }
      }
    },
    "CL_ShirtChino": {
      "name": "Infinite Coral Overshirt<br/>and Chino Pants",
      "world": "CoralLagoon",
      "glb": "Look_CL_ShirtChino_0214",
      "arGlb": "Look_CL_ShirtChino_0214-for-AR",
      "arUsdz": "Look_CL_ShirtChino_0322-for-AR",
      "items": {
        "Infinite_Coral_Overshirt": {
          "name": "Infinite Coral Overshirt",
          "shopUrl": "https://shop.cash.app/product/infinite-coral-overshirt/96",
          "isSoldOut": false
        },
        "Infinite_Coral_Chino_Pants": {
          "name": "Infinite Coral Chino Pants",
          "shopUrl": "https://shop.cash.app/product/infinite-coral-chino-pants/94",
          "isSoldOut": false
        }
      }
    },
    "FT_KnitVest": {
      "name": "Cryptotendril Knit Vest<br/>Dry Earth Chino Pants",
      "world": "FieldTrip",
      "glb": "FT_KnitVest_0211",
      "arGlb": "Look_FT_KnitVest_0214-for-AR",
      "arUsdz": "Look_FT_KnitVest_0322-for-AR",
      "items": {
        "Cryptotendril_Knit_Vest": {
          "name": "Cryptotendril Knit Vest",
          "shopUrl": "https://shop.cash.app/product/cryptotendril-knit-vest/107",
          "isSoldOut": false
        },
        "Dry_Earth_Chino_Pants": {
          "name": "Dry Earth Chino Pants",
          "shopUrl": "https://shop.cash.app/product/dry-earth-chino-pants/100",
          "isSoldOut": false
        }
      }
    },
    "FF_CropSweater": {
      "name": "Kombu Cropped Front Sweatshirt<br/>and Pants",
      "world": "FungiForest",
      "glb": "Look_FF_CropSweater_0220",
      "arGlb": "Look_FF_CropSweater_0220-for-AR",
      "arUsdz": "Look_FF_CropSweater_0322-for-AR",
      "items": {
        "Kombu_Cropped_Front_Sweatshirt": {
          "name": "Kombu Cropped Front Sweatshirt",
          "shopUrl": "https://shop.cash.app/product/kombu-cropped-front-sweatshirt/99",
          "isSoldOut": false
        },
        "Kombu_Sweatpants": {
          "name": "Kombu Sweatpants",
          "shopUrl": "https://shop.cash.app/product/kombu-sweatpants/111",
          "isSoldOut": false
        }
      }
    }
  },
  "rarePlants": {
    "CL_BudBlob": {
      "name": "Bud-Blob",
      "glb": "",
      "bodyCopy": "Slimy and shapeless, the bud-blob does almost nothing but split into smaller and smaller floating blobs, undergoing <strong>inflation</strong> until it’s practically invisible."
    },
    "CL_Venturecoral": {
      "name": "Venture Coral",
      "glb": "",
      "bodyCopy": "Soft and vulnerable, venturecoral takes on <strong>risk</strong> as it stretches out into new waters, but if it survives, its <strong>return</strong> is a feast of delicious psy-krill."
    },
    "FT_Swellberries": {
      "name": "Swellberries",
      "glb": "",
      "bodyCopy": "The fruit of the swellberry bush starts small but ripens rapidly, <strong>appreciating</strong> in value until bursting with sweet juice."
    },
    "FT_Multipod": {
      "name": "Multipod",
      "glb": "",
      "bodyCopy": "The multipod grows seeds of every shape and blasts them off in all directions, <strong>diversifying</strong> its investments to ensure at least some will root and thrive."
    },
    "FF_Rotwood": {
      "name": "Rotwood",
      "glb": "",
      "bodyCopy": "A strange cave plant, rotwood decomposes as it grows, steadily <strong>depreciating</strong> in value until it’s indistinguishable from mulch."
    },
    "FF_Chainshrooms": {
      "name": "Chainshrooms",
      "glb": "",
      "bodyCopy": "A <strong>decentralized</strong> colony organism made up of psychically-linked mushrooms, sprouting separately but growing together, without any guiding authority."
    }
  },
  "uiAudio": {
    "NewLook": {
      "loop": false,
      "src": "New Look v1"
    },
    "RarePlant": {
      "loop": false,
      "src": "Rare plant v2"
    },
    "Soundtrack_CL": {
      "loop": true,
      "src": "CL V3 mix"
    },
    "Soundtrack_FF": {
      "loop": true,
      "src": "FF V3 mix"
    },
    "Soundtrack_FT": {
      "loop": true,
      "src": "FT V3 mix"
    },
    "Soundtrack_General": {
      "loop": true,
      "src": "General V3 mix"
    }
  },
  "manifesto": {
    "copy": [
      "Wherever you are, whatever you are, it is happening.",
      "Somewhere is a coral dreamscape studded with tidepools where soft jewels wave and flicker, nourished on clouds of electrostatic diamond dust.",
      "Somewhere a ten hundred acre spiderweb drifts in low orbit, dragging dozens of blinking spy satellites in its silky tangles.",
      "Somewhere is a remote stretch of tundra gridded with wiry vines and viny wires, all stretching from a single great petal reaching skyward, pulsing with purpose.",
      "Somewhere under an endless floral canopy, a thousand ants from a thousand different distant colonies have arrived at the same patch of earth, ready to dig.",
      "Somewhere a flatworm with a tiny little cell phone is slowly, slowly, slowly dialing your number.",
      "Somewhere, maybe in a mossy cave, the natural and the digital and the material and the expressional are coevolving into the new collection from Cash By Cash App.",
      "Inspired by the vanishing line between organic forms and digitized self-expression, shaped by nature’s unknowable movements, our new collection reflects and celebrates the contours, mystery, and abundance of the natural world.",
      "Somewhere, it is growing."
    ]
  },
  "uiCopy": {
    "shop": "Shop",
    "exploreWorld": "Explore the World",
    "browseCollection": "Browse the Collection",
    "enter": "Enter",
    "manifesto": "Manifesto",
    "discountCodeHeading": "Collection Complete",
    "discountCodeBody": "You’re a true future naturalist.<br/>Screenshot this and share on social with #CashbyCashApp for a chance to win the exclusive Giant Kelp Poncho",
    "landingPageIntro": "<span>Welcome to the new</span> <span>Cash By Cash App collection.</span><br/>Explore the clothing – and the contours and abundance of the natural world – on a virtual <span>nature walk.</span>"
  },
  "menuLinks": [
    { "url": "https://cash.app", "label": "Archive" },
    { "url": "https://cash.app", "label": "Get Cash App" }
  ],
  "shopUrl": "https://shop.cash.app/",
  "discountCodeShopUrl": "https://shop.cash.app/product/giant-kelp-poncho/115",
  "discountCode": "FUTURENATURE",
  "showDiscountCode": true,
  "googleAnalyticsCode": "abc123"
}
